export default document.addEventListener('DOMContentLoaded', () => {
  const bannerCloseButton = document.querySelector('.js-promo-banner-close')

  if (bannerCloseButton) {
    const bannerDateUpdated =
      bannerCloseButton.getAttribute('data-date-updated')

    // On click, remove the banner and store its dateUpdated in local storage
    bannerCloseButton.addEventListener('click', (event) => {
      event.target.closest('.promo-banner').remove()
      localStorage.setItem('promoBannerDismissed', bannerDateUpdated)
    })

    // If the date in local storage matches the dateUpdated from the CMS,
    // remove the banner, otherwise remove the old value from local storage
    if (localStorage.getItem('promoBannerDismissed') === bannerDateUpdated) {
      document.querySelector('.promo-banner').remove()
    } else {
      localStorage.removeItem('promoBannerDismissed')
    }
  }
})
